import { Typography, Box, Divider } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { CustomerMassQueryResult, QueryResultRow } from '../types/query';
import { Customer } from '../../Customer/Model/CustomerModel';
import { CardWrapper } from '../../Common/CommonComponents';
import { getColumns } from '../utils/resultFormator';

interface QueryResultsTableProps {
  data: CustomerMassQueryResult;
  customer: Customer;
}

const QueryResultsTable: React.FC<QueryResultsTableProps> = ({
  data,
  customer,
}) => {
  if (!data || data.length === 0) {
    return (
      <Typography variant="body1" color="textSecondary">
        No results to display.
      </Typography>
    );
  }

  const formatDataForDataGrid = (
    item: Record<string, QueryResultRow[]>,
    index: number,
  ) => {
    const formattedRows: QueryResultRow[] = [];
    Object.entries(item).forEach(([key, value]) => {
      value.forEach((row, rowIndex) => {
        formattedRows.push({
          id: `${index}-${key}-${rowIndex}`,
          ...row,
        });
      });
    });
    return formattedRows;
  };

  return (
    <Box sx={{ width: '100%' }}>
      {data
        .filter((item) => Object.keys(item).includes(customer.Id))
        .map((item, index) => (
          <CardWrapper key={index}>
            <Typography variant="h6" padding={1}>
              {customer.Subdomain} - {customer.Id}
            </Typography>
            <Divider sx={{ mt: 2, mb: 2 }} />
            <DataGrid
              rows={formatDataForDataGrid(item, index)}
              columns={getColumns(Object.values(item)[0][0])}
              autoHeight
            />
          </CardWrapper>
        ))}
    </Box>
  );
};

export default QueryResultsTable;
